import { ConsumerTags, ConsumerTagsWithData, GetConsumerTagsResponseBody, GetConsumerTagsWithDataResponseBody } from './types'

export const transformGetConsumerTagsResponse = (response: GetConsumerTagsResponseBody): ConsumerTags => {
  return Array.from(new Set(response))
}

export const transformGetConsumerTagsWithDataResponse = (response: GetConsumerTagsWithDataResponseBody): ConsumerTagsWithData => {
  return response.reduce((prev, curr) => {
    if (!('key' in curr)) {
      return { ...prev }
    }
    return { ...prev, [curr.key]: curr.value }
  }, {})
}

const TAG_REGEX = /^[a-zA-Z0-9#:\-. ]+$/

const validateTagData = (value?: string): boolean => {
  if (typeof value === 'undefined') {
    return true
  }
  return TAG_REGEX.test(value)
}

export const sanitizeTagData = (value: string | undefined, fallback: string): string | undefined => (validateTagData(value) ? value : fallback)
